/**
 * AudioConfigSection Component
 *
 * Configuration form section for audio generation.
 */

import { memo } from 'react';
import { Volume2 } from 'lucide-react';
import { AudioConfigForm } from '../../components/AudioConfigForm';
import type { AudioGenerationRequest } from '../../types';
import { useTranslation } from '@/hooks/useTranslation';

interface AudioConfigSectionProps {
  onSubmit: (config: AudioGenerationRequest) => void;
  onPreviewScript: (config: AudioGenerationRequest & { topic: string }) => void;
  disabled: boolean;
  isPreviewLoading: boolean;
}

export const AudioConfigSection = memo(function AudioConfigSection({
  onSubmit,
  onPreviewScript,
  disabled,
  isPreviewLoading,
}: AudioConfigSectionProps) {
  const { t } = useTranslation();
  return (
    <div className="card p-6" data-testid="config-form-container">
      <h3 className="text-lg font-semibold text-secondary-900 mb-4 flex items-center space-x-2">
        <Volume2 className="h-5 w-5" />
        <span>{t('audioPage.configSection.title')}</span>
      </h3>
      <AudioConfigForm
        onSubmit={onSubmit}
        onPreviewScript={onPreviewScript}
        disabled={disabled}
        isPreviewLoading={isPreviewLoading}
      />
    </div>
  );
});
